module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud-fog-287aecef6e3ac69b1de805c8f30b84f2.svg";